// extracted by mini-css-extract-plugin
export default {"tabList":"zl39QAS_VNnVkzDc6xqs"};